import React, { Component } from "react";
 
 
import DreamsTable from "./allDreamsTable";
 
import Pagination from "./common/pagination";
import {
   
  getOldDreams 
} from "../services/dreamService";
 
import { paginate } from "../utils/paginate";
import _ from "lodash";
import SearchBox from "./searchBox";

class allDreams extends Component {
  state = {
    dreams: [],
    pcode:0,
    currentPage: 1,
    pageSize: 50,
    searchQuery: "",
    selectedGenre: null,
    sortColumn: { path: "MO_Date", order: "desc" }
  };

  async componentDidMount() {
    let mob = "";
    
    if (this.props.mob) {
      //console.log("this.props.mob  "+this.props.mob );
      mob = this.props.mob;
    } else {
      //console.log(this.props.match.params.mob);
      mob = this.props.match.params.mob;
    }
 
    mob = mob.replace('+', '');
    let pcode = this.props.pcode;
    
    //console.log(" mob  " + mob);
    

    if (mob==="" || !mob ) {
        mob = this.props.mob;
        //console.log(mob);
    }
    let alldata = await getOldDreams( mob);
    alldata = [...alldata.data.Data, ...alldata.data.OldData];
    this.setState({  dreams: alldata ,pcode });
 
  }

 
  handleLike = dream => {
    const dreams = [...this.state.dreams];
    const index = dreams.indexOf(dream);
    dreams[index] = { ...dreams[index] };
    dreams[index].liked = !dreams[index].liked;
    this.setState({ dreams });
  };

  handlePageChange = page => {
    this.setState({ currentPage: page });
  };

  handleGenreSelect = genre => {
    this.setState({ selectedGenre: genre, searchQuery: "", currentPage: 1 });
  };

  handleSearch = query => {
    this.setState({ searchQuery: query, selectedGenre: null, currentPage: 1 });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      selectedGenre,
      searchQuery,
      dreams: allDreams
    } = this.state;
    let filtered = [];
    if (this.props.mob) {
        filtered = allDreams.filter(m => {
        return m.isRedyToSent === true || m.isdelete === true
      });
    } else {
        filtered = allDreams;
    }
    if (searchQuery) {
     // slectedMo = null;
      // let allDreamsMuraqeebDelete=[...allDreams,...dataMuraqeeb];
      // allDreamsMuraqeebDelete=[...allDreamsMuraqeebDelete,...deleteDreams];
      filtered = allDreams.filter(m => {
        if (m["MO_Message"]) {
          var v = false;
          var boolarray = 0;

          var searcharr = searchQuery.split("-");
          if (searcharr.length > 0) {
            for (var i = 0; i < searcharr.length; i++) {
              if (m["MO_Message"].includes(searcharr[i])) {
                boolarray++;
              }
            }
            if (boolarray && searcharr) {
              if (searcharr.length === boolarray) {
                return true;
              }
            }
          }
          v =
            m["MO_Message"] === searchQuery ||
            m["MT_Mobil"] === searchQuery ||
            m["MT_Mobil"].includes(searchQuery) ||
            m["MO_Message"].includes(searchQuery);
          return v;
        } else {
          return (
            m["MO_Message"] === searchQuery || m["MT_Mobil"] === searchQuery
          );
        }
      });
    } 
    else if (selectedGenre && selectedGenre._id)
      filtered = allDreams.filter(m => m.genre._id === selectedGenre._id);

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const dreams = paginate(sorted, currentPage, pageSize);

    return { totalCount: filtered.length, data: dreams };
  };

  render() {
    const { length: count } = this.state.dreams;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;
 
    if (count === 0) return <p>There are no dreams in the database.</p>;

    const { totalCount, data: dreams } = this.getPagedData();

    return (
      <div className="row">
    
        <div className="col">
         
          <p> {totalCount} عدد الأحلام </p>
          <SearchBox value={searchQuery} onChange={this.handleSearch} />
          <DreamsTable
            dreams={dreams}
            sortColumn={sortColumn}
            onLike={this.handleLike}
            pcode={this.props.pcode}
            onSort={this.handleSort}
          />
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

export default allDreams;



// WEBPACK FOOTER //
// ./src/components/allDreams.jsx